import { t } from 'ember-intl';
import { BreadcrumbsItem, LayoutSidebarSubnav } from 'core/components';

<template>
  <BreadcrumbsItem
    @route="terraform.workspaces.detail"
    @text={{t
      "components.page.terraform.workspaces.detail.breadcrumb"
      resourceName=@model.workspace.displayName
      htmlSafe=true
    }}
  />

  <LayoutSidebarSubnav as |Subnav|>
    <Subnav.BackLink
      @text={{t "nav.project.terraform.workspaces.back-to-workspaces"}}
      @route="terraform.workspaces.list"
      data-test-terraform-subnav-link-back
    />
    <Subnav.Title data-test-terraform-subnav-title>
      {{@model.workspace.displayName}}
    </Subnav.Title>
    <Subnav.Link
      @route="terraform.workspaces.detail.index"
      @model={{@model.workspace.resourceId}}
      @text={{t "nav.project.terraform.overview"}}
    />
    <Subnav.Title data-test-terraform-subnav-access-control-title>
      {{t "nav.project.terraform.workspaces.access-control"}}
    </Subnav.Title>
    <Subnav.Link
      @text={{t "nav.project.terraform.workspaces.role-assignments"}}
      @route="terraform.workspaces.detail.role-assignments"
    />
  </LayoutSidebarSubnav>

  {{outlet}}
</template>
